// src/sectors/pilates/reports/staff/pages/StaffReportsPage.jsx
import React, { useState } from 'react';
import Card from '@mui/material/Card';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Icon from '@mui/material/Icon';
import Divider from '@mui/material/Divider';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import SessionsTab from '../tabs/SessionsTab';
import MemberRelationsTab from '../tabs/MemberRelationsTab';
import OverviewTab from '../tabs/OverviewTab';

// ✅ NEW: Görünüm tabı placeholder (istersen ayrı dosyaya böleriz)

function a11yProps(index) {
  return { id: `staff-reports-tab-${index}`, 'aria-controls': `staff-reports-panel-${index}` };
}

function TabPanel({ value, index, children }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`staff-reports-panel-${index}`}
      aria-labelledby={`staff-reports-tab-${index}`}
    >
      {value === index ? <MDBox mt={1.0}>{children}</MDBox> : null}
    </div>
  );
}

export default function StaffReportsPage() {
  const [tab, setTab] = useState(0);

  return (
    <MDBox mt={2} mb={2}>
      <Card
        sx={{
          overflow: 'visible',
          borderRadius: 3,
        }}
      >
        {/* ✅ Tabs bar (iyileştirilmiş) */}
        <MDBox
          px={1.25}
          py={0.9}
          sx={{
            bgcolor: (theme) => theme.palette.grey[100],
            borderBottom: '1px solid rgba(0,0,0,0.06)',
          }}
        >
          <MDBox
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              flexWrap: 'wrap',
            }}
          >
            <Tabs
              value={tab}
              onChange={(e, v) => setTab(v)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                minHeight: 36,

                // container
                '& .MuiTabs-flexContainer': {
                  gap: 0.75,
                },

                // indicator: daha modern
                '& .MuiTabs-indicator': {
                  height: 0, // indicatorı kapatıyoruz, selected style ile çözeceğiz
                },

                '& .MuiTab-root': {
                  minHeight: 36,
                  padding: '6px 10px',
                  fontSize: 12,
                  fontWeight: 800,
                  textTransform: 'none',
                  minWidth: 0,
                  gap: 6,
                  borderRadius: 999,
                  transition: 'all 140ms ease',
                  color: 'text.secondary',

                  '&:hover': {
                    bgcolor: 'rgba(0,0,0,0.05)',
                    color: 'text.primary',
                  },

                  '&.Mui-selected': {
                    bgcolor: 'common.white',
                    color: 'text.primary',
                    boxShadow: '0 6px 16px rgba(0,0,0,0.08)',
                    border: '1px solid rgba(0,0,0,0.06)',
                  },
                },

                '& .MuiTab-iconWrapper': {
                  margin: 0,
                  fontSize: 16,
                },
              }}
            >
              {/* ✅ NEW: Görünüm */}
              <Tab
                icon={<Icon sx={{ fontSize: 16 }}>dashboard</Icon>}
                iconPosition="start"
                label="Görünüm"
                {...a11yProps(0)}
              />

              <Tab
                icon={<Icon sx={{ fontSize: 16 }}>calendar_month</Icon>}
                iconPosition="start"
                label="Seanslar"
                {...a11yProps(1)}
              />

              <Tab
                icon={<Icon sx={{ fontSize: 16 }}>group</Icon>}
                iconPosition="start"
                label="Üye İlişkileri"
                {...a11yProps(2)}
              />
            </Tabs>

            {/* sağ tarafa mini açıklama / ipucu alanı (opsiyonel) */}
            <MDBox sx={{ flex: '1 1 auto' }} />

            <MDTypography variant="caption" sx={{ opacity: 0.75, pr: 0.5 }}>
              Eğitmen performansı • Yoklama • Paket / Ödeme
            </MDTypography>
          </MDBox>
        </MDBox>

        {/* Content */}
        <MDBox px={1.25} pb={1.25} pt={0.6}>
          <TabPanel value={tab} index={0}>
            <OverviewTab />
          </TabPanel>

          <TabPanel value={tab} index={1}>
            <SessionsTab />
          </TabPanel>

          <TabPanel value={tab} index={2}>
            <MemberRelationsTab />
          </TabPanel>
        </MDBox>
      </Card>
    </MDBox>
  );
}
